import studioBR from './studio.br';
import studioMX from './studio.mx';
import studioCL from './studio.cl';
import studioCO from './studio.co';

const studio = {
  BR: studioBR,
  MX: studioMX,
  CL: studioCL,
  CO: studioCO,
};

export default studio;
